import logoMarkSrc from './logo-mark.png';
import logoMarkOnDarkSrc from './logo-mark-on-dark.png';

/** Bundled DentXE product logo (256×256, transparent). */
export const PRODUCT_LOGO_SRC = logoMarkSrc;

/** Navy cross recolored to white for dark UI surfaces (sidebar, login hero). */
export const PRODUCT_LOGO_ON_DARK_SRC = logoMarkOnDarkSrc;

export const PRODUCT_LOGO_ALT = 'DentXE logo';
